<template>
	<div class="main">
		<div class="xybg-main">
			<div class="xybg-title">
				<div class="">重名查询</div>
			</div>
			<div class="xybg-input">
				<van-field v-model="name" @input="input" error placeholder="请输入姓名" />
			</div>
			<div class="xybg-btn">
				<div class="xybg-cxbtn" @click="search()">查询</div>
			</div>
		</div>
		
		<div class="content" v-if="namelist.length>0">
			<div class="total">
				查询到{{namelist.length}}条结果(东楚地区)
			</div>
			<div class="content_div" v-for="(item,i) in namelist" :key="i">
				<div class="content_item">
					<!-- <p>姓名：{{item.name}}</p> -->
					<p>性别：{{item.sex==1?'男':(item.sex==2?"女":'')}}</p>
					<p>年龄：{{item.age?item.age:''}}岁</p>
					<p style="flex:2">出生日期：{{item.date?item.date:''}}</p>
				</div>
				<!-- 	<div class="content_item">
					<p>出生日期：{{item.date}}</p>
				</div>	 -->

			</div>
		</div>
		<div v-else>
			<div class="empty">
				<img src="https://www.mescroll.com/img/mescroll-empty.png" mode="widthFix">
				</img>
				<p>~ 空空如也 ~</p>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	
	export default {
		data() {
			return {
				name: '',
				namelist: []
			}
		},
		computed: {

		},
		onLoad() {
		},
		onShow() {
		},
		methods: {
			input() {
				console.log(this.name)
			},
			search() {
				console.log(this.name)
				//console.log(this.$http)
				 this.$http({				           
					//url:'http://10.241.8.33:8306/hb/cegn/getKjbkjxzxqyrkdjxxjkcx',
					url:'/newdctappapis/checkname',
					params: {
						name: this.name	
					},
					methods:'post',
					headers: {
						'content-type': 'application/x-www-form-urlencoded',
						'api-serviceId':'1531433114763661312',
						'api-appid':'1514893127704514560',
					},
				}).then(res=>{					
					console.log('重名查询',res); 
					if (res.data.code==0) {
						this.firmdata = res.data.result.zxqyData
						console.log('数据', this.firmdata)
					} else {
						Toast.fail(res.msg)
					}
				})
			}			
			//搜索重名
			// async search() {
			// 	if (this.name) {
			// 		uni.showLoading({
			// 			title: '加载中',
			// 			mask: true
			// 		})
			// 		let res = await getcheckname(this.name)
			// 		uni.hideLoading()
			// 		this.namelist = res
			// 		if (this.namelist.length < 1) {
			// 			uni.showToast({
			// 				title: '暂未查到相同姓名！',
			// 				icon: "none",
			// 				duration: 2000
			// 			});
			// 		}
			// 	} else {
			// 		uni.showToast({
			// 			title: '请输入名字',
			// 			icon: "none",
			// 			duration: 2000
			// 		});
			// 	}
			// },

		}
	}
</script>

<style>
	.main {
		padding: 0 30rpx;
	}

	.search {
		display: flex;
		align-items: center;
		margin: 20rpx 0;
		font-size: 36rpx;
		;


	}

	.searchinput {
		flex: 1;
		margin-right: 20rpx;
		;
	}

	.searchinput .btn {
		background-color: #007AFF !important;
		height: 80rpx;
		padding: 20rxp 50rxp;
		display: flex;

	}

	uni-icons {
		margin: auto;
		line-height: 80rpx;
		;
	}

	.content {

		font-size: 28rpx;

	}

	.total {
		font-size: 32rpx;
		padding: 20rpx 0;
	}

	.content_item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		padding: 20rpx 0;
		;

		p {
			flex: 1;
		}
	}

	.content_view {
		margin: 10rpx 0;
		border-bottom: 1rpx solid #E5E5E5;
		padding: 0 10rpx;
		background-color: white;
	}

	//数据为空的图片
	.empty {
		display: flex;
		flex-direction: column;
		align-items: center;

	}

	.empty image {
		margin: auto;
		width: 238rpx;
		height: 238rpx;
		margin-top: 100rpx;
		;
	}
	.xybg-main {
		background-color: white;
		font-size: 18px;
		margin: 24px;
	}
	
	.xybg-title {
		font-weight: 700;
		margin: 10px 0;
	}
	
	.xybg-input {
		margin: 10px 0;
	}
	
	.van-cell {
		padding: 0;
	}
	
	.xybg-input input {
		height: 30px;
		width: 100%;
		border-radius: 10px;
		background: #f9f9f9;
		text-indent: 10px;
	}
	
	.xybg-btn {
		margin: 10px 0;
	}
	
	.xybg-cxbtn {
		background-color: #0076E9;
		border-radius: 10px;
		color: white;
		font-size: 14px;
		text-align: center;
		height: 30px;
		line-height: 30px;
		cursor: pointer;
	}
</style>
